export const getCurrentWeek = (calendar) => {
    const today = new Date();
    const currentWeek = calendar.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      return today >= startDate && today <= endDate;
    });
    return currentWeek ? currentWeek.week : 4; // Default to week 1 if not found
  };

export const formatGameDate = (dateString) => {
  try {
    // Parse ISO date string (YYYY-MM-DD)
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      console.error('Invalid date string:', dateString);
      return 'Invalid Date';
    }

    // Format to "Day, Month DD" (e.g., "Thu, Sep 14")
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error, 'for date string:', dateString);
    return 'Invalid Date';
  }
};